export default "__VITE_ASSET__b4d87852__"